/*
 * File Created: Tuesday, 3rd January 2023 3:27:37 pm
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

type scroll = "toTop" | "next";

/**
 *
 * @param scroll toTop | next
 *
 */
export const useScroll = (scroll: scroll) => {
  if (scroll === "toTop") {
    return function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
  } else if (scroll === "next") {
    return function () {
      // window.sc
      window.scrollTo({ top: window.innerHeight, behavior: "smooth" });
      console.count("USESCROLL : NEXT : ");
    };
  }
};
